// strip inline images

(function ($) {
  'use strict';

  $.extend(true, $.trumbowyg, {
      plugins: {
          allowTagsFromPaste: {
              init: function (trumbowyg) {
                  trumbowyg.pasteHandlers.push(function () {
                      setTimeout(function () {
                          var processNodes = trumbowyg.$ed.html();
                          console.log(processNodes)
                          processNodes = processNodes.replace(/<img[^>]*src=\"data:image\/.+;base64[^>]*>/g,'')
                          trumbowyg.$ed.html(processNodes);
                      }, 0);
                  });
              }
          }
      }
  });
})(jQuery);
